import React from "react";
import { Formik, Field, Form as FormikForm } from "formik";
import * as Yup from "yup";
import { useMutation } from "@tanstack/react-query";
import { postRequest } from "../services/apiMethods";
import Layout from "../Componants/Layout";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";

const validationSchema = Yup.object().shape({
  email: Yup.string().email("Invalid email address").required("Email is required"),
});

export default function ForgotPassword() {
  const Navigate = useNavigate();

  const { mutate, isLoading: apiState } = useMutation({
    mutationFn: (data) => {
      return postRequest(`/auth/forgot`, data);
    },
    onSuccess: (data) => {
      toast.success(`${data?.message}`, {
        iconTheme: {
            primary: '#337FE0',
            secondary: '#FFFAEE',
        },
    })
      // setTimeout(() => {
      //   toast.dismiss();
      //   window.location.href = "/dashboard";
      // }, 1500);
    },
    onError: (error) => {
      console.error("Error during API call:", error);
    },
  });


  const handleSubmit = (values) => {
    mutate(values)

  };

  return (
    <Layout>
      <section>
        <div className="comn-form-box">
          <div>
            <h2>Forgot Password?</h2>
            <p>Don’t worry! It occurs. Please enter the email address linked with your account</p>
            <Formik
              initialValues={{ email: "" }}
              validationSchema={validationSchema}
              onSubmit={handleSubmit}
            >
              {({ errors, touched }) => (
                <FormikForm className="cmn-form-set">
                  <div className="mb-3">
                    <label htmlFor="email" className="form-label">Email</label>
                    <Field
                      name="email"
                      type="email"
                      placeholder="Enter email"
                      className={`form-control ${errors.email && touched.email ? "is-invalid" : ""}`}
                    />
                    {errors.email && touched.email && (
                      <div className="invalid-feedback">{errors.email}</div>
                    )}
                  </div>

                  <div className="cmn-form-action">
                    <button type="submit" className="theme-btn">
                      {apiState ? "loading..." : "Send"}
                    </button>
                  </div>
                </FormikForm>
              )}
            </Formik>
          </div>
        </div>
      </section>
    </Layout>
  );
}
